/**
 * @generated SignedSource<<88adbe951f0bcbb0a4288823e7f07e5c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type checkoutShippingReducer_emailUser$data = {
  readonly profile: {
    readonly email: string | null;
  } | null;
  readonly " $fragmentType": "checkoutShippingReducer_emailUser";
};
export type checkoutShippingReducer_emailUser$key = {
  readonly " $data"?: checkoutShippingReducer_emailUser$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutShippingReducer_emailUser">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutShippingReducer_emailUser"
};

(node as any).hash = "207e3750d7e0dd2a266f71b8fc65feda";

export default node;
